
import { combineReducers } from 'redux'
import assets from './assets'

export default combineReducers({
  assets
})